@use "../../../../../styles/Colors.scss" as Colors;
@use "../../../../../styles/Constants.scss" as Constants;
@use "../../../../../components/Table/styles.module.scss" as Table;

$var-shadow: 0 1px 4px 0 Colors.$col-shadow;
$var-submit-action-top-offset: -16px;
$var-tabs-navigation-top-offset: 48px;
$var-lost-for-reason-width: 250px;
$val-action-header-height: 2 * Constants.$val-spacing-m;

.rtv-table {
	&__filter-button {
		border: 1px solid Colors.$col-greyMid;
		border-radius: Constants.$val-borderRadius;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		display: flex;
		align-items: center;
		background: Colors.$col-white;
	}

	&__selected-job {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
}

.filter-container {
	display: flex;
}

.side-panel-header {
	display: flex;
	height: 100%;
	align-items: center;
	justify-content: flex-start;
	margin-left: Constants.$val-spacing-l;
	text-transform: uppercase;
	font-weight: bold;

	& > [class^="icon-"] {
		cursor: pointer;
		color: Colors.$col-blue;
		font-size: Constants.$val-fontSizeXBig;
		margin-right: Constants.$val-spacing-m;
	}
}

.empty-table-message {
	color: Colors.$col-greyDark;
	background: Colors.$col-greyBackground;
	padding: Constants.$val-spacing-m;
}

.table-filters {
	width: 100%;
	display: flex;
	gap: Constants.$val-spacing-s;
	padding-right: Constants.$val-spacing-xl;

	> div:first-child {
		flex: 1;
		margin-right: 0;

		& > a > span {
			right: Constants.$val-spacing-xl;
			left: unset;
		}

		& > input {
			width: 100% !important; // search on table has fixed width so it messes up css on smaller screens
		}
	}
}

.canceled-work-order-status-cell {
	display: flex;
	justify-content: center;
}
